class CopyButton {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-copybutton',
            onCopied: null
        };

        this.settings = Object.assign({}, settings, options);
        this.$element = element;
        const target = this.$element.getAttribute(this.settings.initAttr);

        if (typeof target !== 'undefined') {
            this.$target = document.querySelector(target);
            // this.initialize();
        }
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$element.addEventListener('click', (e) => {
            this.addToClipboard(this.$target);
            e.preventDefault();
        });
    }

    addToClipboard (el) {
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            // save current contentEditable/readOnly status
            const editable = el.contentEditable;
            const readOnly = el.readOnly;

            // convert to editable with readonly to stop iOS keyboard opening
            el.contentEditable = true;
            el.readOnly = true;

            // create a selectable range
            const range = document.createRange();
            range.selectNodeContents(el);

            // select the range
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            el.setSelectionRange(0, 999999);

            // restore contentEditable/readOnly to original state
            el.contentEditable = editable;
            el.readOnly = readOnly;
        } else {
            el.select();
        }

        // execute copy command
        navigator.clipboard.writeText(el.getAttribute('value'));

        if (typeof this.settings.onCopied === 'function') {
            this.settings.onCopied();
        }
    }
}

export { CopyButton };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $copyButton = $context.querySelectorAll('[data-copybutton]');
        if ($copyButton.length > 0) {
            for (let i = 0; i < $copyButton.length; i++) {
                const copyButton = new CopyButton($copyButton[i], {
                    onCopied: () => {
                        $copyButton[i].innerText = 'Link kopiert';

                        setTimeout(() => {
                            $copyButton[i].innerText = 'Link kopieren';
                        }, 1000);
                    }
                });

                copyButton.initialize();
            }
        }
    }
});
